import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function NavMenuLayout() {
  const locaiton = useLocation()
  const pathname = locaiton.pathname

  const navigate = useNavigate()
  const menuSubList = useSelector((state) => state.allMenuReducer.allMenu)
  const [newMenu, setNewMenu] = useState([])

  useEffect(() => {
    if (menuSubList && menuSubList.allMenu) {
      const menuMain = menuSubList.allMenu.find((item) => item.id === 11) //id emp

      if (menuMain) {
        const subMenu = menuMain.submenu.find((item) => item.menuId === 3) //id cln

        if (subMenu?.menuSubList.length > 0) {
          setNewMenu(subMenu?.menuSubList)
        }
      }
    }
  }, [menuSubList])

  return (
    <div className="my-auto ">
      {newMenu.map((d, i) => (
        <label
          key={i}
          className={`border-0 my-auto pointer-event fw-bold me-3 ${
            pathname !== d.link && 'opacity-25'
          }`}
          style={{
            fontSize: '16px'
          }}
          onClick={() => {
            navigate(d.link)
          }}
        >
          {d.label}
        </label>
      ))}
    </div>
  )
}
